export default __webpack_public_path__ + "static/media/hong-kong.b03f13d5.png";